import React from 'react';

const About: React.FC = () => {
  return (
    <section id="about" className="py-24 bg-white dark:bg-neutral-dark-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Column */}
          <div className="fade-in-up">
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-neutral-900 dark:text-neutral-dark-900 mb-6">
              Digital. Simplified.
            </h2>

            <p className="text-lg text-neutral-600 dark:text-neutral-dark-600 leading-relaxed">
              We put your business and your customers at the heart of everything we do. We build
              websites, automations, and marketing strategies that deliver measurable results—without
              the jargon, the complexity, or the wasted time.
            </p>
          </div>

          {/* Right Column - Values Card */}
          <div className="fade-in-up animation-delay-200">
            <div className="bg-gradient-to-br from-primary-indigo to-primary-indigoLight rounded-xl p-8 text-white shadow-xl">
              <h3 className="text-xl md:text-2xl font-semibold mb-6">What makes us different</h3>

              <ul className="space-y-4">
                <li className="flex items-start">
                  <svg
                    className="w-5 h-5 text-accent-emerald mr-3 mt-1 flex-shrink-0"
                    aria-hidden="true"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>We measure success by your results, not by what we deployed.</span>
                </li>

                <li className="flex items-start">
                  <svg
                    className="w-5 h-5 text-accent-emerald mr-3 mt-1 flex-shrink-0"
                    aria-hidden="true"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>You'll always know what we're doing and why.</span>
                </li>

                <li className="flex items-start">
                  <svg
                    className="w-5 h-5 text-accent-emerald mr-3 mt-1 flex-shrink-0"
                    aria-hidden="true"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Your customers come first in every decision, not our preferences.</span>
                </li>

                <li className="flex items-start">
                  <svg
                    className="w-5 h-5 text-accent-emerald mr-3 mt-1 flex-shrink-0"
                    aria-hidden="true"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>We track what matters and keep improving until the numbers move.</span>
                </li>
              </ul>

              <div className="mt-8 pt-6 border-t border-white/20">
                <p className="text-lg font-semibold">
                  We won't do something if we can't explain why it will help your business.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
